<template>
  <v-modal v-if="loaded" id="modal-report-firme-csv" :is-big="false" :modal="false">
    <span slot="header"> {{ i18nJS['domestics.reports.report_firme'] }}<br /> </span>
    <slot name="body">
      <div class="flex">
        <div class="filters flex flex-cols form-content">
          <p v-if="showErrors" class="alert alert-danger text-center">
            {{ i18nJS['domestics.reports.dates_required'] }}
          </p>
          <template v-if="filterByDate">
            <datepicker
              class="input_date obbligatorio"
              v-model="filters.from"
              placeholder="Dal"
              :required="filterByDate"
              id="firme_csv_date_from"
            />
            <div class="spacer" />
            <datepicker
              class="input_date obbligatorio"
              v-model="filters.to"
              placeholder="Al"
              :required="filterByDate"
              id="firme_csv_date_to"
            />
          </template>
          <template v-else>
            <v-select2 v-if="months" v-model="filters.month" :options-list="months" :data-allow-clear="false" :data-minimumInputLength="1">
            </v-select2>
            <div class="spacer" />
            <v-select2 v-if="years" v-model="filters.year" :options-list="years" :data-allow-clear="false" :data-minimumInputLength="1">
            </v-select2>
          </template>
          <div class="spacer" />
          <div v-if="!treeListViewFilter">
            <v-select2
              v-model="filters.guestSelected"
              :multiple="true"
              :data-placeholder="i18nJS.guest_label"
              :data-ajax--url="`${guestUrl}`"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
            <v-select2
              v-model="filters.departmentSelected"
              :multiple="false"
              :data-placeholder="i18nJS['domestics.daily_table.department']"
              :options-list="departmentOptionsList"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
            <v-select2
              v-model="filters.userSelected"
              :multiple="false"
              :data-placeholder="i18nJS.user_label"
              data-ajax--url="/it/users?type[]=presents&type[]=cessati"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
            <v-select2
              v-model="filters.activitySelected"
              :multiple="true"
              :data-placeholder="i18nJS.activities"
              :data-ajax--url="activityAjaxUrl"
              data-minimumInputLength="0"
              data-pageLimit="20"
              data-allow-clear="true"
            >
            </v-select2>
            <div class="spacer" />
          </div>
          <div v-else>
            <div class="tree-max">
              <a class="button" @click="loadActivities(false)">{{ i18nJS.activities }}</a>
              <div v-if="activityShow">
                <template v-if="activityOptionsList.length">
                  <div v-for="(activity, idx) in activityOptionsList" :key="idx">
                    <input type="checkbox" :value="activity.id" v-model="filters.activitySelected" />&nbsp;{{ activity.label }}
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
            <div class="tree-max">
              <a class="button" @click="loadGuests(false)">{{ i18nJS.guest_label }}</a>
              <div v-if="guestShow">
                <template v-if="guestOptionsList.length">
                  <div v-for="(guest, idx) in guestOptionsList" :key="idx">
                    <input type="checkbox" :id="`firme_csv_guest_${guest.id}`" :value="guest.id" v-model="filters.guestSelected" />&nbsp;{{
                      guest.label
                    }}
                    <label :for="`firme_csv_guest_${guest.id}`"></label>
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
            <div class="tree-max">
              <a class="button" @click="loadDepartments()">{{ i18nJS['domestics.daily_table.department'] }}</a>
              <div v-if="departmentShow">
                <input type="checkbox" :value="null" v-model="filters.departmentSelected" />&nbsp;{{ i18nJS.no_preference }}
                <template v-if="departmentOptionsList.length">
                  <div v-for="(bu, idx) in departmentOptionsList" :key="idx">
                    <input type="checkbox" :value="bu.id" v-model="filters.departmentSelected" />&nbsp;{{ bu.label }}
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
            <div class="tree-max">
              <a class="button" @click="loadUsers(false)"
                >{{ i18nJS.user_label }}
                <span v-if="usersIsLoading">{{ i18nJS.is_loading }}</span>
              </a>
              <div v-if="userShow">
                <template v-if="userOptionsList.length">
                  <div v-for="(user, idx) in userOptionsList" :key="idx">
                    <input type="checkbox" :value="user.id" v-model="filters.userSelected" />&nbsp;{{ user.label }}
                  </div>
                </template>
              </div>
            </div>
            <div class="spacer" />
          </div>
          <div class="">
            <label>{{ i18nJS['filter_sign.title'] }}</label>
            <label for="firme_csv_all" class="inline">
              <input type="radio" id="firme_csv_all" value="all" v-model="filters.signed" />
              {{ i18nJS.all }}
            </label>
            <label for="firme_csv_signed" class="inline">
              <input type="radio" id="firme_csv_signed" value="signed" v-model="filters.signed" />
              {{ i18nJS['filter_sign.signed'] }}
            </label>
            <label for="firme_csv_unsigned" class="inline">
              <input type="radio" id="firme_csv_unsigned" value="unsigned" v-model="filters.signed" />
              {{ i18nJS['filter_sign.unsigned'] }}
            </label>
          </div>
        </div>
      </div>
    </slot>
    <a slot="footer" ref="btnSave" class="btn btn-success button-download" @click="downloadReportFirme()"> Scarica </a>
  </v-modal>
</template>
<script>
import { LabelApi } from '@/epersonam/mixins/labels.js';
import apiConnector from '@/epersonam/apiConnector';
import vModal from '../vModal';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';
import { getPdf, downloadPdf } from './template';
import DOMPurify from 'dompurify';
import { Route } from '../../route';

export default {
  name: 'modalReportFirmeCsv',
  mixins: [LabelApi],
  components: {
    vModal,
    vSelect2,
    datepicker,
  },
  async beforeMount() {
    this.neededlabels = [
      'errors.critical_error',
      'domestics.reports.report_firme',
      'is_loading',
      'user_label',
      'domestics.daily_table.department',
      'no_preference',
      'filter_sign.title',
      'all',
      'filter_sign.signed',
      'filter_sign.unsigned',
      'guest_label',
      'activities',
      'domestics.reports.dates_required',
    ];
    await this.setupLabels();
    this.loaded = true;
  },
  mounted() {
    eventBus.$on('openModalReportFirmeCsv', () => {
      this.showErrors = false;
      if (!this.filterByDate) {
        this.months = Object.keys(this.i18nJS.months).map((month, index) => {
          return [this.i18nJS.months[month], String(index + 1).padStart(2, '0')];
        });
        this.years = Array.from(new Array(this.currentYear - 2000).keys()).map((ele) => [
          String(this.currentYear - ele),
          String(this.currentYear - ele),
        ]);
      }
      if (!this.treeListViewFilter) {
        if (this.departmentOptionsList.length === 0) {
          apiConnector()
            .get(`/${window.locale}/business_units/units_list.json?business_unit_id=${this.currentBuId}`)
            .then(({ data }) => {
              this.departmentOptionsList = data;
            })
            .catch((err) => {
              console.err('Could not initialize departmentOptionsList', err);
            });
        }
      }
      $('#modal-report-firme-csv').modal('show');
    });
  },
  computed: {
    activityAjaxUrl() {
      return `/${window.locale}/activities_configs`;
    },
  },
  props: {
    currentBuId: {
      type: Number,
      required: true,
      default: 0,
    },
    treeListViewFilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    filterByDate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    let additionalFilters = {};
    if (this.filterByDate) {
      additionalFilters = {
        from: moment().startOf('month').format('L'),
        to: moment().endOf('month').format('L'),
      };
    } else {
      additionalFilters = {
        month: moment().format('MM'),
        year: `${new Date().getFullYear()}`,
      };
    }
    return {
      loaded: false,
      filters: {
        ...additionalFilters,
        signed: 'all',

        guestSelected: this.treeListViewFilter ? [] : null,
        userSelected: this.treeListViewFilter ? [] : null,
        departmentSelected: this.treeListViewFilter ? [] : null,
        activitySelected: this.treeListViewFilter ? [] : null,
      },
      showErrors: false,
      months: [],
      years: [],
      currentYear: new Date().getFullYear(),

      // Options list
      userOptionsList: [],
      activityOptionsList: [],
      activityIsLoading: false,
      activityPaginationPage: 1,
      guestBusinessUnitsOptionsList: [],
      departmentOptionsList: [],
      guestOptionsList: [],

      userShow: false,
      usersIsLoading: false,
      activityShow: false,
      guestShow: false,
      departmentShow: false,

      // URL FOR RETRIVE DATA FOR TREE-LIST-VIEW
      baseUrl: window.config.ePersonamService.ePersonamHost + '/' + window.locale,
      baseFormat: '.json',
      // url per lista utenti in base alle mansioni
      loadUsersUrl: '/users',
      loadUsersOutedUrl: '/users/outed',
      usersPage: 1,
      // url per la lista delle attività filtrati per area
      loadActivitiesUrl: '/activities_configs',
      // url per la lista delle sub attività filtrati per attività
      loadDepartmentsUrl: '/business_units/units_list',
      // url per la lista delle sub attività filtrati per attività
      loadGuestsUrl: '/guests',
      guestsPage: 1,
      guestUrl: `${Route.GUEST_BUSINESS_UNIT_AUTOCOMPLETE_GUESTS_FULL_NAME}?from_report_firme=true`,
    };
  },
  destroyed() {
    console.log('Ho distrutto il modale!');
  },
  methods: {
    loadUsers(nextPage) {
      if (!this.treeListViewFilter) {
        return;
      }
      if (!nextPage && this.userOptionsList?.length) {
        this.userShow = this.userShow !== true;
        return;
      }
      this.usersIsLoading = true;
      const calls = [
        apiConnector().get(this.baseUrl + this.loadUsersUrl + this.baseFormat, { params: { page: this.usersPage } }),
        apiConnector().get(this.baseUrl + this.loadUsersOutedUrl + this.baseFormat, { params: { page: this.usersPage } }),
      ];
      Promise.all(calls)
        .then(([res1, res2]) => {
          res1.data.forEach((val) => {
            if (!val.surname || !val.firstname) {
              return;
            }

            this.userOptionsList.push({ id: val.id, label: `${val.surname} ${val.firstname}` });
          });
          res2.data.forEach((val) => {
            if (!val.full_name) {
              return;
            }
            this.userOptionsList.push({ id: val.id, label: val.full_name });
          });
          this.userOptionsList.sort(function (a, b) {
            return a.label.localeCompare(b.label);
          });

          if (res1.data.length || res2.data.length) {
            this.usersPage += 1;
            this.loadUsers(true);
          } else {
            this.usersIsLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.userShow = true;
    },
    loadActivities(nextPage) {
      if (!this.treeListViewFilter) {
        return;
      }
      if (!nextPage && this.activityOptionsList?.length) {
        this.activityShow = this.activityShow !== true;
        return;
      }
      apiConnector()
        .get(this.baseUrl + this.loadActivitiesUrl + this.baseFormat, {
          params: {
            business_unit_id: this.currentBuId,
            type: 'activity',
            page: this.activityPaginationPage,
          },
        })
        .then(({ data: res }) => {
          res.forEach((val) => {
            this.activityOptionsList.push({ id: val.id, label: val.description });
            this.activityShow = true;
          });

          if (res.length) {
            this.activityIsLoading = true;
            this.activityPaginationPage += 1;
            this.loadActivities(this.activityIsLoading);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadDepartments() {
      if (!this.treeListViewFilter) {
        return;
      }
      if (this.departmentOptionsList?.length) {
        this.departmentShow = this.departmentShow !== true;
        return;
      }
      apiConnector()
        .get(this.baseUrl + this.loadDepartmentsUrl + this.baseFormat, { params: { business_unit_id: this.currentBuId } })
        .then(({ data: res }) => {
          res.forEach((val) => {
            if (this.departmentOptionsList?.findIndex((x) => x.id === val[1] || x.label === val[0]) !== -1) {
              return;
            }
            this.departmentOptionsList.push({ id: val[1], label: val[0] });
            this.departmentShow = true;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadGuests(nexPage) {
      if (!this.treeListViewFilter) {
        return;
      }
      if (!nexPage && this.guestOptionsList.length) {
        this.guestShow = this.guestShow !== true;
        return;
      }
      apiConnector()
        .get(this.baseUrl + this.loadGuestsUrl + this.baseFormat, { params: { page: this.guestsPage, with_gpds: true } })
        .then(({ data: res }) => {
          res.forEach((val) => {
            this.guestOptionsList.push({ id: val.guest_business_unit_id, label: val.full_name });
            this.guestShow = true;
          });
          if (res.length !== 0) {
            this.guestsPage += 1;
            this.loadGuests(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // TreeView filter query - FINE

    buildParams() {
      let params = {
        business_unit_id: this.currentBuId,
        from: `${this.filters.month}/${this.filters.year}`,
        signed: this.filters.signed,
      };

      if (this.filterByDate) {
        params = {
          ...params,
          from: this.filters.from,
          to: this.filters.to,
          filter_by_date: this.filterByDate,
        };
      }

      if (this.filters.guestSelected && this.filters.guestSelected.length > 0) {
        params.guest_id = this.filters.guestSelected;
      }
      if (this.filters.userSelected && this.filters.userSelected.length > 0) {
        params.user_id = this.filters.userSelected;
      }
      if (this.filters.departmentSelected && this.filters.departmentSelected.length > 0) {
        params.department_id = this.filters.departmentSelected;
      }
      if (
        this.filters.activitySelected &&
        this.filters.activitySelected.length > 0 &&
        this.filters.activitySelected.filter((activity) => activity !== '').length > 0
      ) {
        params.activity_id = this.filters.activitySelected;
      }

      return params;
    },

    downloadReportFirme() {
      let valid = false;
      if (this.filterByDate) {
        valid = this.filters.from && this.filters.to;
      } else {
        valid = this.filters.month && this.filters.year;
      }

      if (!valid) {
        this.showErrors = true;
        return;
      }

      this.showErrors = false;
      Loader.show();
      apiConnector()
        .post(`/${window.locale}/reports/generate_report`, {
          ...this.buildParams(),
          type: 'csv',
          worker: 'ReportFirmeWorker',
          business_unit_id: this.config.business_unit.id,
        })
        .then(() => {
          Loader.hide();
          $('#modal-report-firme-csv').modal('hide');
        })
        .catch((err) => {
          let msg = `${i18nJS['errors.critical_error']}: ${err.message} - ${err.response.data}`;
          if (err.response.status === 401) {
            msg = i18nJS['access_denied'];
          }
          Utils.appendToFlash('error', msg);
          Loader.hide();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
#modal-report-firme-csv {
  .modal-body {
    max-height: unset;
  }
}

.flex {
  display: flex;
}

.flex-cols {
  flex-direction: column;
}

.filters {
  width: 100%;
}

.form-content {
  ::v-deep .select2-container,
  ::v-deep .datepicker,
  ::v-deep .input_date,
  ::v-deep .v-select2 {
    width: 100% !important;
  }
}

.button-pdf {
  border: unset;
  background-color: white;
}

.button-download {
  margin-left: 10px;
}

.spacer {
  height: 20px;
}

.tree-max {
  max-height: 300px;
  overflow-y: auto;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;

  input {
    margin-top: 0;
  }

  .tree-child:first-child {
    margin: 2px 0 0 10px;
  }

  .tree-child {
    margin: 0 0 0 15px;
  }

  .element-father {
    position: relative;
    overflow-y: auto;

    .icon {
      position: absolute;
      right: 0;
      top: 2px;
    }
  }
}
</style>
